import { render, staticRenderFns } from "./StudySubmission.vue?vue&type=template&id=9878daa6&"
import script from "./StudySubmission.vue?vue&type=script&lang=ts&"
export * from "./StudySubmission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports